import { render } from "./logicControl.vue?vue&type=template&id=204e105e"
import script from "./logicControl.vue?vue&type=script&lang=js"
export * from "./logicControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__